






















import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
    import {PriceListStore} from "@/modules/pricelists/store";
    import debounce from "lodash/debounce";
    import {PriceListParams} from "@/modules/pricelists/params";
    import {CommonStatus} from "@/enums/status";
    import PriceListLabel from "@/modules/pricelists/List/components/Label.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";

    @Component({
        name: "PriceListSelector",
        components: {PriceListLabel}
    })
    export default class extends mixins(CommonMixin) {
        @Model("change")
        readonly priceListId!: number|number[];
        @Prop({ default: true, type: Boolean}) readonly refresh!: boolean

        @Emit('change')
        handleChange(value: number|undefined) {
            return value;
        }

        @Prop({ default: "default", type: String })
        readonly mode!: string;

        @Prop({ default: false })
        readonly disabled!: boolean;

        @Prop({ default: "Chọn bảng giá", type: String })
        readonly placeholder!: string;

        @Prop({ default: () => this.currentPostOffice.rowGuid })
        readonly postOfficeRowGuid!: string;

        @Prop({ default: () => LIMIT_PAGE_DEFAULT })
        readonly limit!: number;

        get ids(): number[] {
            return PriceListStore.idByPostOffice[this.postOfficeRowGuid];
        }

        async created() {
            try {
                if (this.ids?.length) return;
                await this.listPriceList({});
                // if (this.priceListId && !this.ids?.includes(this.priceListId as any))
                //     this.handleChange(undefined);
            } catch (e) {
                console.log(e);
                this.$message.error({ content: e?.response?.data?.message || "Đã có lỗi xảy ra" });
            }
        }

        handleSearch = debounce(function (value: string, vm: any) {
            vm.listPriceList({ search: value });
        }, 500);
        
        private onSearch(value: string) {
            this.handleSearch(value, this)
        }

        @Watch('postOfficeRowGuid')
        onchangePostOfficeRowGuid(val: any) {
            this.listPriceList({ postOfficeRowGuid: val })
        }

        @Watch('priceListId', { immediate: true })
        async onchangePriceListId(val: any) {
            if (val && !this.ids?.includes(val)) {
                await PriceListStore.singlePriceList(val);
            }
        }

        async listPriceList({search, postOfficeRowGuid = this.postOfficeRowGuid, status = CommonStatus.Active, limit = this.limit}: any) {
            try {
                await PriceListStore.listPriceList({
                   params: {
                       ...new PriceListParams(),
                       search,
                       postOfficeRowGuid,
                       status,
                       limit
                   }
                });
            } catch (e) {
            }
        }
    }
